import React, { useState, useEffect } from "react";

import usePortalStyles from "../styles/portalStyles";

import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import { Formik, Field, Form } from "formik";
import MuiTextField from "@material-ui/core/TextField";
import { TextField, TextFieldProps, Checkbox } from "formik-material-ui";

import * as Yup from "yup";

import queryString from "query-string";

import axios from "axios";

import { kickRed } from "../../shared/styles/baseStyles.js";

const initialValues = {
  passwordResetToken: "",
  password: "",
  email: "",
};

export default function PortalPasswordReset(props) {
  const [passwordResetError, setPasswordResetError] = useState("");
  const [passwordResetMessage, setPasswordResetMessage] = useState(<p></p>);
  const [passwordResetSuccess, setPasswordResetSuccess] = useState(false);

  const parsedQS = queryString.parse(location.search);

  if (parsedQS.token) {
    initialValues.passwordResetToken = parsedQS.token;
  }

  const passwordValidationSchema = Yup.object().shape({
    password: Yup.string()
      .min(6, "Please enter a password with at least 6 characters")
      .required("Password is required"),
  });

  const emailValidationSchema = Yup.object().shape({
    email: Yup.string().email().required("Email is required"),
  });

  const renderInputEmailForm = () => {
    return (
      <Formik
        validationSchema={emailValidationSchema}
        initialValues={initialValues}
        onSubmit={(values, { setSubmitting }) => {
          axios
            .put("/me/password-reset/", {
              email: values.email,
            })
            .then((response) => {
              // console.log("response returned");
              setSubmitting(false);
              // console.log("RESPONSE:", response);
              const jsonData = response.data.data;
              // console.log("submitted. Return:", jsonData);

              setPasswordResetMessage(
                <p style={{ color: kickRed }}>
                  Email sent. Check your inbox for a reset email. <br />
                  Make sure to check your spam folder too.
                </p>
              );
              setPasswordResetError("");
            })

            //   if (apiTokenJWT) {
            //     const location = {
            //       pathname: "/me/portal"
            //     };
            //     this.props.history.push(location);
            //   } else {
            //     console.error("Error: Invalid Login Token received");
            //   }
            // })
            .catch((error) => {
              setSubmitting(false);
              console.error("Error resetting password:", error.response);

              setPasswordResetError(error.response.data.errors[0].title);
              setPasswordResetMessage(<p></p>);
            });

          // action("submit")(values);
        }}
      >
        {(props) => (
          <Form
            style={{
              display: "flex",
              width: "300px",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <p>What email address did you use to sign up?</p>
            <Field
              component={TextField}
              id="email"
              name="email"
              label="Email"
              type="email"
              variant="outlined"
              fullWidth
            />

            <div
              style={{
                textAlign: "center",
                marginTop: "10px",
                color: "red",
              }}
            >
              {passwordResetError}
            </div>
            <div
              style={{
                textAlign: "center",
                marginTop: "10px",
              }}
            >
              {passwordResetMessage}
            </div>

            <Button
              disabled={props.isSubmitting}
              type="submit"
              color="primary"
              size="large"
              style={{
                backgroundColor: "#f25930",
                color: "white",
                marginTop: "10px",
                width: "80%",
                justifySelf: "center",
                alignSelf: "center",
                display: "flex",
                flex: "1",
                // fontSize: "16px",
                // fontWeight: "medium",
                textTransform: "unset",
              }}
            >
              Send Password Reset Email
            </Button>
          </Form>
        )}
      </Formik>
    );
  };

  const renderNewPasswordForm = () => {
    let passwordResetSuccessMsg = [
      <p>
        Password successfully changed.
        <br />
        {/* <a href="/visits/pac/signup">Start Your Performance Visit</a>
        <br /> */}
        <a href="/me">Login For Treatments, Refills and Messaging</a>
      </p>,
    ];
    return (
      <Formik
        validationSchema={passwordValidationSchema}
        initialValues={initialValues}
        onSubmit={(values, { setSubmitting }) => {
          axios
            .post("/me/password-reset/", {
              passwordResetToken: values.passwordResetToken,
              password: values.password,
            })
            .then((response) => {
              setSubmitting(false);

              const jsonData = response.data.data;

              setPasswordResetSuccess(true);

              //   if (apiTokenJWT) {
              //   const location = {
              //     pathname: "/me/login"
              //   };
              //   this.props.history.push(location);
              //   } else {
              //     console.error("Error: Invalid Login Token received");
              //   }
            })
            .catch((error) => {
              setSubmitting(false);
              console.error("Error resetting password:", error.response);

              setPasswordResetError(error.response.data.errors[0].title);
            });

          // action("submit")(values);
        }}
        render={({
          submitForm,
          isSubmitting,
          values,
          setpasswordResetErrorValue,
        }) => (
          <Form
            style={{
              display: "flex",
              width: "280px",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {!passwordResetSuccess && (
              <React.Fragment>
                <p>Please Enter a New Password</p>
                <Field
                  component={TextField}
                  id="password"
                  name="password"
                  label="Password"
                  type="password"
                  variant="outlined"
                  style={{ marginTop: "16px" }}
                  fullWidth
                  onKeyPress={(ev) => {
                    if (ev.key === "Enter") {
                      submitForm();
                    }
                  }}
                />

                <div
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    color: "red",
                  }}
                >
                  {passwordResetError}
                </div>
              </React.Fragment>
            )}

            <div style={{ textAlign: "center" }}>
              {passwordResetSuccess ? passwordResetSuccessMsg : null}
            </div>
            {!passwordResetSuccess && (
              <React.Fragment>
                {passwordResetError && (
                  <a style={{ marginTop: "10px" }} href="/me/password-reset">
                    Request New Password Reset Email
                  </a>
                )}

                <Button
                  disabled={isSubmitting}
                  type="submit"
                  color="primary"
                  size="large"
                  style={{
                    backgroundColor: "#f25930",
                    color: "white",
                    marginTop: "10px",
                    width: "80%",
                    justifySelf: "center",
                    alignSelf: "center",
                    display: "flex",
                    flex: "1",
                    // fontSize: "18px",
                    // fontWeight: "medium",
                    textTransform: "unset",
                  }}
                >
                  Update Password
                </Button>
              </React.Fragment>
            )}
          </Form>
        )}
      />
    );
  };
  return (
    <Grid
      container
      justifyContent="center"
      style={{
        backgroundColor: "#3f3f82",

        height: "100vh",
      }}
    >
      <Grid item style={{}} md={8} xs={10}>
        <div
          style={{
            backgroundColor: "white",
            display: "flex",
            justifyContent: "center",
            height: "330px",
            marginTop: "200px",
            alignSelf: "center",
            borderRadius: "10px",
          }}
        >
          <div
            style={{
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              style={{
                fontFamily: "BasisGrotesquePro-Bold",
                // fontWeight: "bold",
                fontSize: "24px",
                textAlign: "center",
                margin: "30px 0 20px 0",
              }}
            >
              Choose New Password
            </Typography>
            {initialValues.passwordResetToken
              ? renderNewPasswordForm()
              : renderInputEmailForm()}
          </div>
        </div>
      </Grid>
    </Grid>
  );
}
